export const HOME_CSW_AS_SLIDER = 'com-home-csw-as-slider'
export const ODS_ZAVA_MODAL = 'com-pdp-ods-modal'
export const SERP_TOP_PRODUCTS_NAME = 'com-serp-top-products'
export const HOME_SWAP_CSW_AND_SERVICES = 'com-home-swap-csw-and-services'
export const PDP_GTM_BLOCK_MONITOR = 'com-client-block-monitor'
export const AFTER_QUERY_SUGGEST_LAYER = 'search-box-aqsl'
export const COMPACT_PDP_SHORT_DESCRIPTION =
  'compact-pdp-with-short-description'
export const ALT_SERP_AT = 'new-serp-layout-at'
